import { Navigate, Outlet, NavLink } from "react-router-dom";
import { useState } from "react";

export default function AdminLayout() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/admin/login" />;
  }

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/admin/login";
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <header className="bg-white shadow-sm border-b border-gray-200 px-4 md:px-6 py-0 flex items-center justify-between h-16 sticky top-0 z-50">
        <h1 className="text-lg md:text-xl font-bold text-gray-900">Admin Panel</h1>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex gap-2 items-center flex-wrap">
          <NavLink
            to="/admin/products"
            end
            className={({ isActive }) =>
              `px-4 py-2 rounded-md text-sm font-medium transition-all ${
                isActive
                  ? "bg-gray-100 text-primary font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            Products
          </NavLink>
          <NavLink
            to="/admin/reviews"
            className={({ isActive }) =>
              `px-4 py-2 rounded-md text-sm font-medium transition-all ${
                isActive
                  ? "bg-gray-100 text-primary font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            Reviews
          </NavLink>
          <NavLink
            to="/admin/settings"
            className={({ isActive }) =>
              `px-4 py-2 rounded-md text-sm font-medium transition-all ${
                isActive
                  ? "bg-gray-100 text-primary font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            Settings
          </NavLink>
          <button
            className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-all"
            onClick={handleLogout}
          >
            Logout
          </button>
        </nav>

        {/* Mobile Hamburger Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden p-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={closeMenu}
        />
      )}

      {/* Mobile Navigation Menu */}
      <nav
        className={`fixed top-16 left-0 right-0 bg-white shadow-lg border-b border-gray-200 z-40 transform transition-transform duration-300 ease-in-out md:hidden ${
          isMenuOpen ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="px-4 py-2 space-y-1">
          <NavLink
            to="/admin/products"
            end
            onClick={closeMenu}
            className={({ isActive }) =>
              `block px-4 py-3 rounded-md text-base font-medium transition-all ${
                isActive
                  ? "bg-gray-100 text-primary font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            Products
          </NavLink>
          <NavLink
            to="/admin/reviews"
            onClick={closeMenu}
            className={({ isActive }) =>
              `block px-4 py-3 rounded-md text-base font-medium transition-all ${
                isActive
                  ? "bg-gray-100 text-primary font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            Reviews
          </NavLink>
          <NavLink
            to="/admin/settings"
            onClick={closeMenu}
            className={({ isActive }) =>
              `block px-4 py-3 rounded-md text-base font-medium transition-all ${
                isActive
                  ? "bg-gray-100 text-primary font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            Settings
          </NavLink>
          <button
            className="w-full text-left px-4 py-3 rounded-md text-base font-semibold text-gray-700 hover:bg-gray-100 transition-all border-t border-gray-200 mt-2"
            onClick={() => {
              closeMenu();
              handleLogout();
            }}
          >
            Logout
          </button>
        </div>
      </nav>

      <main className="flex-1 p-4 md:p-8 max-w-7xl w-full mx-auto">
      <Outlet />
      </main>
    </div>
  );
}
